import { Container } from "aurelia-framework";
import { Router } from "aurelia-router";
import store from "../store";
import { IState, LocationState, IState as IState1 } from "../state";
import { Api } from "../../services/api";
import { applicationLogger } from "../../logging/logger";
import { Location } from "../../models/location";
import * as Enumerable from "linq-es2015";
import { HubManager } from "../../services/hub-manager";

const api: Api = Container.instance.get(Api);
const hubManager = Container.instance.get(HubManager);
const router = Container.instance.get(Router);
export async function addLocation(state: IState, location: Location) {
	const newState = Object.assign({}, state);
	applicationLogger.debug("Adding new location");
	const newLocation = await api.addLocation(location);
	newState.locationState.locations.push(newLocation);
	return newState;
}

export async function updateLocation(state: IState, location: Location) {
	const newState = Object.assign({}, state);

	applicationLogger.debug(`Updating location, code: ${location.code}, id: ${location.id}`);

	let index = newState.locationState.locations.findIndex(((l: Location) => l.id === location.id) as any);
	if (index > -1) {
		newState.locationState.locations[index] = location;
	}

	index = newState.locationState.selectedLocations.findIndex(((l: Location) => l.id === location.id) as any);
	if (index > -1) {
		newState.locationState.locations[index] = location;
	}

	return newState;
}

export async function clearLocalStorage(state: IState) {

	const newState = Object.assign({}, state);
	
	try {
		applicationLogger.info(`Current route: ${router.currentInstruction.config.name}`);
		// stop the SignalR connections from receiving data.  This prevents the 
		// Aurelia Store from updating the "greenhouse-storage-key" while we're fetching the 
		// latest location hierarchy data.
		hubManager.disposeHubs();

		// Remove the location hierarchy from local storage
		localStorage.removeItem("greenhouse-storage-key");

		// request location hierarchy
		newState.locationState.version = 0;
		const x = await getLocationHierarchy(newState);
		// force the browser to reload at the current URL.
		document.location.reload();
		return x;
	} catch (e) {
		return Object.assign({}, state);
	}
	
}

export async function getLocationHierarchy(state: IState) {
	const newState = Object.assign({}, state);
	try {
		applicationLogger.debug("Fetching location hierarchy");
		const locationHierarchy = await api.getLocationHierarchy(newState.locationState.version);

		if (newState.locationState.version !== locationHierarchy.version) {
			newState.locationState.version = locationHierarchy.version;
			newState.locationState.initialized = true;
			newState.locationState.locations = locationHierarchy.locations;
			const locations = newState.locationState.locations;
			const selectedLocations = newState.locationState.selectedLocations;
			if (selectedLocations.length === 0) {
				for (let i = 0; i < locations.length; i++) {
					selectedLocations[i] = locations[i];
				}
			} else {
				const existingSelectedLocations = Enumerable.From(state.locationState.selectedLocations).Select(l => l.id).ToArray();
				for (let i = 0; i < locations.length; i++) {
					const location = locations[i];
					if (existingSelectedLocations.indexOf(location.id) > -1) {
						selectedLocations[i] = location;
					}
				}
			}
		}
	} catch (e) {
		applicationLogger.error("Unexpected error.", e);
	}
	return newState;
}

export function updateLocationState(state: IState, locationState: LocationState) {
	const newState = Object.assign({}, state);
	newState.locationState = locationState;
	return newState;
}

// register actions here...
store.registerAction("addLocation", addLocation);
store.registerAction("updateLocation", updateLocation);
store.registerAction("getLocationHierarchy", getLocationHierarchy);
store.registerAction("updateLocationState", updateLocationState);
store.registerAction("clearLocalStorage", clearLocalStorage);
